import { TuiCountryIsoCode } from '@taiga-ui/i18n';
import { Locale, Maybe } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toTuiCountryIsoCode',
  standalone: true,
})
export class ToTuiCountryIsoCodePipe implements PipeTransform {
  public transform(code: Maybe<Locale>): TuiCountryIsoCode | null {
    if (code === Locale.Dk) return TuiCountryIsoCode.DK;
    if (code === Locale.Uk) return TuiCountryIsoCode.GB;
    if (code === Locale.Pl) return TuiCountryIsoCode.PL;
    if (code === Locale.Ie) return TuiCountryIsoCode.IE;
    return null;
  }
}
